import {
  Tabs,
  Tab,
  Button,
  Modal,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useState, useRef } from "react";
import "./referencedata.scss";
import Swal from "sweetalert2";
import { MdDelete, MdClose, MdSearch, MdEdit, MdRemoveRedEye } from "react-icons/md";

// Tab data
const tabsData = [
  "Abbreviations",
  "Aliases",
  "Anglicized",
  "Bad Data",
  "Double letters",
  "Initial",
  "Nick Name",
  "Intervening",
  "MT202",
];

// Sample data for abbreviations
const initialAbbreviations = [
  {
    id: 1,
    name: "Societa di Gestione del Risparmio",
    abbreviation: "S.G.R.",
    createdBy: "Admin",
  },
  {
    id: 2,
    name: "5G",
    abbreviation: "Fifth Generation",
    createdBy: "Admin",
  },
  {
    id: 3,
    name: "A. EN P.",
    abbreviation: "Asociación en Participación",
    createdBy: "Admin",
  },
  {
    id: 4,
    name: "A.G.",
    abbreviation: "AktienGesellschaft",
    createdBy: "Admin",
  },
];

// Sample data for aliases
const initialAliases = [
  {
    id: 1,
    name: "BANCO NACIONAL DE CUBA",
    aliasword: "BNC",
    createdBy: "Admin",
  },
  {
    id: 2,
    name: "EMPRESA CUBANA DE PESCADOS Y MARISCOS",
    aliasword: "CARIBEX",
    createdBy: "Admin",
  },
  {
    id: 3,
    name: "ABU MARZOOK, Mousa Mohammed",
    aliasword: "ABU-UMAR",
    createdBy: "Admin",
  },
  {
    id: 4,
    name: "RODRIGUEZ OREJUELA, Gilberto Jose",
    aliasword: "THE CHESS PLAYER",
    createdBy: "Admin",
  },
  {
    id: 5,
    name: "RODRIGUEZ OREJUELA, Gilberto Jose",
    aliasword: "LUCAS",
    createdBy: "Admin",
  },
];

// Sample data for anglicized names
const initialAnglicized = [
  {
    id: 1,
    name: "AID",
    anglicizedName: "Aide",
    createdBy: "Admin",
  },
  {
    id: 2,
    name: "ELZA",
    anglicizedName: "Elsa",
    createdBy: "Admin",
  },
  {
    id: 3,
    name: "ADEN",
    anglicizedName: "Aiden",
    createdBy: "Admin",
  },
  {
    id: 4,
    name: "Arin",
    anglicizedName: "Erin",
    createdBy: "Admin",
  },
  {
    id: 5,
    name: "KARA",
    anglicizedName: "Cara",
    createdBy: "Admin",
  },
];

// Sample data for bad data
const initialBadData = [
  {
    id: 1,
    name: "!",
    description: "Exclamation mark",
    createdBy: "Admin",
  },
  {
    id: 2,
    name: "@",
    description: "At symbol",
    createdBy: "Admin",
  },
  {
    id: 3,
    name: "#",
    description: "Hash symbol",
    createdBy: "Admin",
  },
  {
    id: 4,
    name: "$",
    description: "Dollar sign",
    createdBy: "Admin",
  },
  {
    id: 5,
    name: "%",
    description: "Percent sign",
    createdBy: "Admin",
  },
];

// Sample data for double letters
const initialDoubleLetters = [
  {
    id: 1,
    name: "AA",
    replaceLetter: "A",
    createdBy: "Admin",
  },
  {
    id: 2,
    name: "BB",
    replaceLetter: "B",
    createdBy: "Admin",
  },
  {
    id: 3,
    name: "CC",
    replaceLetter: "C",
    createdBy: "Admin",
  },
  {
    id: 4,
    name: "DD",
    replaceLetter: "D",
    createdBy: "Admin",
  },
  {
    id: 5,
    name: "EE",
    replaceLetter: "E",
    createdBy: "Admin",
  },
];

// Sample data for initials
const initialInitials = [
  {
    id: 1,
    name: "ABAHUSSAIN",
    initial: "A.",
    createdBy: "Admin",
  },
  {
    id: 2,
    name: "ABAUNZA",
    initial: "A",
    createdBy: "Admin",
  },
  {
    id: 3,
    name: "ABBAS",
    initial: "A",
    createdBy: "Admin",
  },
];

// Sample data for nicknames
const initialNicknames = [
  {
    id: 1,
    name: "Aamir",
    nickname: "Ami",
    createdBy: "Admin",
  },
  {
    id: 2,
    name: "Aamir",
    nickname: "Aam",
    createdBy: "Admin",
  },
  {
    id: 3,
    name: "Abaunza",
    nickname: "Aba",
    createdBy: "Admin",
  },
  {
    id: 4,
    name: "Abaunza",
    nickname: "Abau",
    createdBy: "Admin",
  },
];

// Sample data for intervining
const initialIntervining = [
  {
    id: 1,
    wordList: "UNKNOWN",
    description: "Unknown or unidentified entity",
    createdBy: "Admin",
  },
  {
    id: 2,
    wordList: "AGENT",
    description: "A person who acts on behalf of another",
    createdBy: "Admin",
  },
  {
    id: 3,
    wordList: "PAYMENT",
    description: "Transfer of money or goods in exchange for services",
    createdBy: "Admin",
  },
  {
    id: 4,
    wordList: "HIDDEN",
    description: "Concealed or not visible",
    createdBy: "Admin",
  },
  {
    id: 5,
    wordList: "NAMED",
    description: "Having a specific designation or title",
    createdBy: "Admin",
  },
];

function ReferenceData() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [mt202Files, setMt202Files] = useState([]);
  const [mt202ImportModal, setMt202ImportModal] = useState(false);
  const [mt202File, setMt202File] = useState(null);
  const [mt202Generate, setMt202Generate] = useState(false);
  const [mt202Apply, setMt202Apply] = useState(false);
  const [mt202ViewRow, setMt202ViewRow] = useState(null);

  const handleMt202Import = () => {
    setMt202ImportModal(true);
    setMt202File(null);
  };
  const handleMt202FileChange = (e) => {
    setMt202File(e.target.files[0]);
  };
  const handleMt202Submit = (e) => {
    e.preventDefault();
    if (mt202File) {
      setMt202Files((prev) => [
        ...prev,
        {
          id: Date.now(),
          fileName: mt202File.name,
          uploadedAt: new Date().toLocaleString(),
        },
      ]);
      setMt202ImportModal(false);
    }
  };
  const handleMt202Generate = () => {
    setMt202Generate(true);
    setMt202Apply(false);
  };
  

  const previewTableData = [
    {
      id: 0,
      col1: "BANKSESSXXXX",
      col2: "I103BANKNO2XXXXN",
      col3: "SEPA, MNO987123654",
      col4: "",
      col20: "REF987123654",
      col23B: "CRED",
      col32A: "240303SEK3000",
      col50A: "/9871236540 OLIVER ERICSON",
      col57A: "BANKNO2X",
      col59: "/5566778899 HENRY JOHNSTON",
      col70: "HOUSE RENT",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
    {
      id: 1,
      col1: "BANKFIHHXXXX",
      col2: "I103BANKDKKKXXXXN",
      col3: "SEPA, PQR456789123",
      col4: "",
      col20: "REF456789123",
      col23B: "CRED",
      col32A: "240303SEK5000",
      col50A: "/4567891230 EMMA WILSON",
      col57A: "BANKDKKKX",
      col59: "/1122334455 JAMES BROWN",
      col70: "CAR LOAN",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
    {
      id: 2,
      col1: "BANKPTPLXXXX",
      col2: "I103BANKGRXXXXXXN",
      col3: "SEPA, STU654321987",
      col4: "",
      col20: "REF654321987",
      col23B: "CRED",
      col32A: "240303SEK7000",
      col50A: "/6543219870 LUCAS MARTIN",
      col57A: "BANKGRXXX",
      col59: "/9988776655 SARAH DAVIS",
      col70: "HOME RENOVATION",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
    {
      id: 3,
      col1: "BANKESPBXXXX",
      col2: "I103BANKITRRXXXXN",
      col3: "SEPA, VWX321654987",
      col4: "",
      col20: "REF321654987",
      col23B: "CRED",
      col32A: "240303SEK4000",
      col50A: "/3216549870 SOPHIA LEE",
      col57A: "BANKITRRX",
      col59: "/4455667788 MICHAEL WHITE",
      col70: "EDUCATION",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
    {
      id: 4,
      col1: "BANKDEFFXXXX",
      col2: "I103BANKFRXXXXXXN",
      col3: "SEPA, YZA987654321",
      col4: "",
      col20: "REF987654321",
      col23B: "CRED",
      col32A: "240303SEK6000",
      col50A: "/9876543210 THOMAS CLARK",
      col57A: "BANKFRXXX",
      col59: "/6677889900 LUCY ADAMS",
      col70: "BUSINESS EXPENSE",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
  ];

  // Helper function to get columns and data for the current tab
  const getTableConfig = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return {
          columns: [
            { label: "Name", key: "name" },
            { label: "Abbreviation", key: "abbreviation" },
            { label: "Created By", key: "createdBy" },
          ],
          data: abbreviations,
        };
      case 1:
        return {
          columns: [
            { label: "Name", key: "name" },
            { label: "Alias", key: "aliasword" },
            { label: "Created By", key: "createdBy" },
          ],
          data: aliases,
        };
      case 2:
        return {
          columns: [
            { label: "Name", key: "name" },
            { label: "Anglicized Name", key: "anglicizedName" },
            { label: "Created By", key: "createdBy" },
          ],
          data: anglicized,
        };
      case 3:
        return {
          columns: [
            { label: "Name", key: "name" },
            { label: "Description", key: "description" },
            { label: "Created By", key: "createdBy" },
          ],
          data: badData,
        };
      case 4:
        return {
          columns: [
            { label: "Name", key: "name" },
            { label: "Replace Letter", key: "replaceLetter" },
            { label: "Created By", key: "createdBy" },
          ],
          data: doubleLetters,
        };
      case 5:
        return {
          columns: [
            { label: "Name", key: "name" },
            { label: "Initial", key: "initial" },
            { label: "Created By", key: "createdBy" },
          ],
          data: initials,
        };
      case 6:
        return {
          columns: [
            { label: "Name", key: "name" },
            { label: "Nickname", key: "nickname" },
            { label: "Created By", key: "createdBy" },
          ],
          data: nicknames,
        };
      case 7:
        return {
          columns: [
            { label: "Word List", key: "wordList" },
            { label: "Description", key: "description" },
            { label: "Created By", key: "createdBy" },
          ],
          data: intervining,
        };
      default:
        return { columns: [], data: [] };
    }
  };

  const [abbreviations, setAbbreviations] = useState(initialAbbreviations);
  const [aliases, setAliases] = useState(initialAliases);
  const [anglicized, setAnglicized] = useState(initialAnglicized);
  const [badData, setBadData] = useState(initialBadData);
  const [doubleLetters, setDoubleLetters] = useState(initialDoubleLetters);
  const [initials, setInitials] = useState(initialInitials);
  const [nicknames, setNicknames] = useState(initialNicknames);
  const [intervining, setIntervining] = useState(initialIntervining);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editFormData, setEditFormData] = useState({
    name: "",
    abbreviation: "",
    aliasword: "",
    anglicizedName: "",
  });
  const [createFormData, setCreateFormData] = useState({
    name: "",
    abbreviation: "",
    aliasword: "",
    anglicizedName: "",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const fileInputRef = useRef(null);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    if (selectedTab === 0) {
      setEditFormData({
        name: item.name,
        abbreviation: item.abbreviation,
      });
    } else if (selectedTab === 1) {
      setEditFormData({
        name: item.name,
        aliasword: item.aliasword,
      });
    } else if (selectedTab === 2) {
      setEditFormData({
        name: item.name,
        anglicizedName: item.anglicizedName,
      });
    } else if (selectedTab === 3) {
      setEditFormData({
        name: item.name,
        description: item.description,
      });
    } else if (selectedTab === 4) {
      setEditFormData({
        name: item.name,
        replaceLetter: item.replaceLetter,
      });
    } else if (selectedTab === 5) {
      setEditFormData({
        name: item.name,
        initial: item.initial,
      });
    } else if (selectedTab === 6) {
      setEditFormData({
        name: item.name,
        nickname: item.nickname,
      });
    } else if (selectedTab === 7) {
      setEditFormData({
        wordList: item.wordList,
        description: item.description,
      });
    }
    setEditModalOpen(true);
  };

  const handleDeleteClick = (id) => {
    if (selectedTab === 0) {
      setAbbreviations(abbreviations.filter((item) => item.id !== id));
    } else if (selectedTab === 1) {
      setAliases(aliases.filter((item) => item.id !== id));
    } else if (selectedTab === 2) {
      setAnglicized(anglicized.filter((item) => item.id !== id));
    } else if (selectedTab === 3) {
      setBadData(badData.filter((item) => item.id !== id));
    } else if (selectedTab === 4) {
      setDoubleLetters(doubleLetters.filter((item) => item.id !== id));
    } else if (selectedTab === 5) {
      setInitials(initials.filter((item) => item.id !== id));
    } else if (selectedTab === 6) {
      setNicknames(nicknames.filter((item) => item.id !== id));
    } else if (selectedTab === 7) {
      setIntervining(intervining.filter((item) => item.id !== id));
    }
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    if (selectedTab === 0) {
      setAbbreviations(
        abbreviations.map((item) =>
          item.id === selectedItem.id
            ? {
                ...item,
                name: editFormData.name,
                abbreviation: editFormData.abbreviation,
              }
            : item
        )
      );
    } else if (selectedTab === 1) {
      setAliases(
        aliases.map((item) =>
          item.id === selectedItem.id
            ? {
                ...item,
                name: editFormData.name,
                aliasword: editFormData.aliasword,
              }
            : item
        )
      );
    } else if (selectedTab === 2) {
      setAnglicized(
        anglicized.map((item) =>
          item.id === selectedItem.id
            ? {
                ...item,
                name: editFormData.name,
                anglicizedName: editFormData.anglicizedName,
              }
            : item
        )
      );
    } else if (selectedTab === 3) {
      setBadData(
        badData.map((item) =>
          item.id === selectedItem.id
            ? {
                ...item,
                name: editFormData.name,
                description: editFormData.description,
              }
            : item
        )
      );
    } else if (selectedTab === 4) {
      setDoubleLetters(
        doubleLetters.map((item) =>
          item.id === selectedItem.id
            ? {
                ...item,
                name: editFormData.name,
                replaceLetter: editFormData.replaceLetter,
              }
            : item
        )
      );
    } else if (selectedTab === 5) {
      setInitials(
        initials.map((item) =>
          item.id === selectedItem.id
            ? {
                ...item,
                name: editFormData.name,
                initial: editFormData.initial,
              }
            : item
        )
      );
    } else if (selectedTab === 6) {
      setNicknames(
        nicknames.map((item) =>
          item.id === selectedItem.id
            ? {
                ...item,
                name: editFormData.name,
                nickname: editFormData.nickname,
              }
            : item
        )
      );
    } else if (selectedTab === 7) {
      setIntervining(
        intervining.map((item) =>
          item.id === selectedItem.id
            ? {
                ...item,
                wordList: editFormData.wordList,
                description: editFormData.description,
              }
            : item
        )
      );
    }
    setEditModalOpen(false);
  };
  const [summaryData, setSummaryData] = useState([
    {
      id: 1,
      fileName: "ofac-2024-03-15-120000_processed",
      scenario: "Bad_data",
      count: 100,
    },
    {
      id: 2,
      fileName: "pep-2024-03-15-130000_processed",
      scenario: "Run together",
      count: 150,
    },
    {
      id: 3,
      fileName: "uk-sanctions-2024-03-15-140000_processed",
      scenario: "Aliases",
      count: 200,
    },
  ]);
  const [modalCurrentPage, setModalCurrentPage] = useState(1);
  const [summaryModal, setSummaryModal] = useState(false);
  const handleSummaryModal = () => {
    setSummaryModal(!summaryModal);
  };
  const handleModalFirstPage = () => {
    setModalCurrentPage(1);
  };

  const handleModalLastPage = () => {
    setModalCurrentPage(Math.ceil(summaryData.length / itemsPerPage));
  };

  const handleModalPrevPage = () => {
    setModalCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleModalNextPage = () => {
    setModalCurrentPage((prev) =>
      Math.min(prev + 1, Math.ceil(summaryData.length / itemsPerPage))
    );
  };

  const modalIndexOfLastItem = modalCurrentPage * itemsPerPage;
  const modalIndexOfFirstItem = modalIndexOfLastItem - itemsPerPage;
  const modalCurrentItems = summaryData.slice(
    modalIndexOfFirstItem,
    modalIndexOfLastItem
  );

  // Add search handler
  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  // Add pagination functions
  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(Math.ceil(abbreviations.length / itemsPerPage));
  };

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) =>
      Math.min(prev + 1, Math.ceil(abbreviations.length / itemsPerPage))
    );
  };

  // Filter items based on search term
  const filteredItems =
    selectedTab === 0
      ? abbreviations.filter((row) =>
          Object.values(row).some(
            (value) =>
              value && value.toString().toLowerCase().includes(searchTerm)
          )
        )
      : selectedTab === 1
      ? aliases.filter((row) =>
          Object.values(row).some(
            (value) =>
              value && value.toString().toLowerCase().includes(searchTerm)
          )
        )
      : selectedTab === 2
      ? anglicized.filter((row) =>
          Object.values(row).some(
            (value) =>
              value && value.toString().toLowerCase().includes(searchTerm)
          )
        )
      : selectedTab === 3
      ? badData.filter((row) =>
          Object.values(row).some(
            (value) =>
              value && value.toString().toLowerCase().includes(searchTerm)
          )
        )
      : selectedTab === 4
      ? doubleLetters.filter((row) =>
          Object.values(row).some(
            (value) =>
              value && value.toString().toLowerCase().includes(searchTerm)
          )
        )
      : selectedTab === 5
      ? initials.filter((row) =>
          Object.values(row).some(
            (value) =>
              value && value.toString().toLowerCase().includes(searchTerm)
          )
        )
      : selectedTab === 6
      ? nicknames.filter((row) =>
          Object.values(row).some(
            (value) =>
              value && value.toString().toLowerCase().includes(searchTerm)
          )
        )
      : intervining.filter((row) =>
          Object.values(row).some(
            (value) =>
              value && value.toString().toLowerCase().includes(searchTerm)
          )
        );

  const handleCreateClick = () => {
    setCreateFormData({
      name: "",
      abbreviation: "",
      aliasword: "",
      anglicizedName: "",
    });
    setCreateModalOpen(true);
  };

  const handleCreateFormChange = (e) => {
    const { name, value } = e.target;
    setCreateFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCreateSubmit = (e) => {
    e.preventDefault();
    if (selectedTab === 0) {
      const newAbbreviation = {
        id: Math.max(...abbreviations.map((item) => item.id)) + 1,
        name: createFormData.name,
        abbreviation: createFormData.abbreviation,
        createdBy: "Admin",
      };
      setAbbreviations([...abbreviations, newAbbreviation]);
    } else if (selectedTab === 1) {
      const newAlias = {
        id: Math.max(...aliases.map((item) => item.id)) + 1,
        name: createFormData.name,
        aliasword: createFormData.aliasword,
        createdBy: "Admin",
      };
      setAliases([...aliases, newAlias]);
    } else if (selectedTab === 2) {
      const newAnglicized = {
        id: Math.max(...anglicized.map((item) => item.id)) + 1,
        name: createFormData.name,
        anglicizedName: createFormData.anglicizedName,
        createdBy: "Admin",
      };
      setAnglicized([...anglicized, newAnglicized]);
    } else if (selectedTab === 3) {
      const newBadData = {
        id: Math.max(...badData.map((item) => item.id)) + 1,
        name: createFormData.name,
        description: createFormData.description,
        createdBy: "Admin",
      };
      setBadData([...badData, newBadData]);
    } else if (selectedTab === 4) {
      const newDoubleLetter = {
        id: Math.max(...doubleLetters.map((item) => item.id)) + 1,
        name: createFormData.name,
        replaceLetter: createFormData.replaceLetter,
        createdBy: "Admin",
      };
      setDoubleLetters([...doubleLetters, newDoubleLetter]);
    } else if (selectedTab === 5) {
      const newInitial = {
        id: Math.max(...initials.map((item) => item.id)) + 1,
        name: createFormData.name,
        initial: createFormData.initial,
        createdBy: "Admin",
      };
      setInitials([...initials, newInitial]);
    } else if (selectedTab === 6) {
      const newNickname = {
        id: Math.max(...nicknames.map((item) => item.id)) + 1,
        name: createFormData.name,
        nickname: createFormData.nickname,
        createdBy: "Admin",
      };
      setNicknames([...nicknames, newNickname]);
    } else if (selectedTab === 7) {
      const newIntervining = {
        id: Math.max(...intervining.map((item) => item.id)) + 1,
        wordList: createFormData.wordList,
        description: createFormData.description,
        createdBy: "Admin",
      };
      setIntervining([...intervining, newIntervining]);
    }
    setCreateModalOpen(false);
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const content = e.target.result;

        console.log("File content:", content);
        Swal.fire({
          icon: "success",
          title: "File Uploaded!",
        });
      };
      reader.readAsText(file);
    }
  };

  return (
    <div className="home-page">
      <div className="page-container">
        {/* Add hidden file input */}
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileUpload}
          style={{ display: "none" }}
          accept=".csv,.xlsx,.xls,.txt"
        />

        {/* Horizontal Scrolling Tabs */}
        <div className="d-flex justify-content-between align-items-center border-bottom mb-3">
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="reference data tabs"
            sx={{
              "& .MuiTabs-indicator": {
                display: "none",
              },
              "& .MuiTab-root": {
                color: "rgba(0, 0, 0, 0.6)",
                backgroundColor: "#ccc",
                padding: "15px",
                borderRadius: "4px 4px 0 0",
                marginRight: "5px",

                "&.Mui-selected": {
                  backgroundColor: "var(--theme-color)",
                  color: "white",
                  borderRadius: "4px 4px 0 0",
                },
              },
            }}
          >
            {tabsData.map((tab, index) => (
              <Tab key={index} label={tab} />
            ))}
          </Tabs>
        </div>

        {/* Abbreviations Table */}
        {selectedTab === 0 && (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-end">
                <button
                  className="anchor-button me-3"
                  onClick={handleSummaryModal}
                >
                  View History
                </button>
                <div>
                  <TextField
                    fullWidth
                    size="small"
                    variant="standard"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={handleSearch}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MdSearch />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiInput-underline:before": {
                        borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottom: "2px solid var(--theme-color)",
                      },
                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottom: "2px solid rgba(0, 0, 0, 0.87)",
                      },
                    }}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center">
                <button
                  className="btn createButton me-2"
                  onClick={handleUploadClick}
                >
                  Upload
                </button>
                <button
                  className="btn createButton"
                  onClick={handleCreateClick}
                >
                  Create
                </button>
              </div>
              {/* changes done */}
            </div>
            <div className="overflow-auto">
              <table
                className="table table-bordered table-striped"
                id="abbreviationsTable"
              >
                <thead className="table-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Abbreviations</th>
                    <th scope="col">Created By</th>
                    <th scope="col" className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems
                    .slice(
                      (currentPage - 1) * itemsPerPage,
                      currentPage * itemsPerPage
                    )
                    .map((row, index) => (
                      <tr key={row.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{row.name}</td>
                        <td>{row.abbreviation}</td>
                        <td>{row.createdBy}</td>
                        <td className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            className="btn btn-primary  btn-sm"
                            onClick={() => handleEditClick(row)}
                          >
                            <MdEdit /> Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(row.id)}
                          >
                            <MdDelete /> Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <div className="pagination">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleFirstPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  First
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  Prev
                </Button>
                <span className="mx-2 align-self-center">
                  Page {currentPage} of{" "}
                  {Math.ceil(filteredItems.length / itemsPerPage)}
                </span>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleNextPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                  className="me-2"
                >
                  Next
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleLastPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                >
                  Last
                </Button>
              </div>
            </div>
          </>
        )}

        {/* History Modal */}
        <Modal
          open={summaryModal}
          onClose={handleSummaryModal}
          aria-labelledby="history-modal-title"
          aria-describedby="history-modal-description"
        >
          <div className="modal-overlay">
            <div
              className="modal-container bg-white p-4 rounded"
              style={{ minWidth: 400 }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5 id="history-modal-title">History</h5>
                <IconButton onClick={handleSummaryModal}>
                  <MdClose />
                </IconButton>
              </div>
              <div className="overflow-auto">
                <table className="table table-bordered table-striped">
                  <thead className="table-dark">
                    <tr>
                      {getTableConfig(selectedTab).columns.map((col) =>
                        col.key === "createdBy" ? (
                          <th key="createdDate">Created Date</th>
                        ) : (
                          <th key={col.key}>{col.label}</th>
                        )
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {getTableConfig(selectedTab)
                      .data.slice(modalIndexOfFirstItem, modalIndexOfLastItem)
                      .map((row, idx) => (
                        <tr key={row.id || idx}>
                          {getTableConfig(selectedTab).columns.map((col) =>
                            col.key === "createdBy" ? (
                              <td key="createdDate">
                                {new Date(
                                  Date.now() -
                                    Math.floor(
                                      Math.random() * 1000 * 60 * 60 * 24 * 365
                                    )
                                )
                                  .toLocaleDateString("en-GB")
                                  .replace(/\//g, "-")}
                              </td>
                            ) : (
                              <td key={col.key}>{row[col.key]}</td>
                            )
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-end mt-2">
                <Button
                  variant="outlined"
                  size="small"
                  className="me-2"
                  onClick={handleModalFirstPage}
                  disabled={modalCurrentPage === 1}
                >
                  First
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  className="me-2"
                  onClick={handleModalPrevPage}
                  disabled={modalCurrentPage === 1}
                >
                  Prev
                </Button>
                <span style={{ margin: "0 8px" }}>
                  Page {modalCurrentPage} of{" "}
                  {Math.ceil(
                    getTableConfig(selectedTab).data.length / itemsPerPage
                  )}
                </span>
                <Button
                  variant="outlined"
                  size="small"
                  className="me-2"
                  onClick={handleModalNextPage}
                  disabled={
                    modalCurrentPage ===
                    Math.ceil(
                      getTableConfig(selectedTab).data.length / itemsPerPage
                    )
                  }
                >
                  Next
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  className="me-2"
                  onClick={handleModalLastPage}
                  disabled={
                    modalCurrentPage ===
                    Math.ceil(
                      getTableConfig(selectedTab).data.length / itemsPerPage
                    )
                  }
                >
                  Last
                </Button>
              </div>
            </div>
          </div>
        </Modal>

        {/* Aliases Table */}
        {selectedTab === 1 && (
          <>
            <div className="row mb-3 justify-content-between align-items-center">
              <div className="col-md-2">
                <TextField
                  fullWidth
                  size="small"
                  variant="standard"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdSearch />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottom: "2px solid var(--theme-color)",
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottom: "2px solid rgba(0, 0, 0, 0.87)",
                    },
                  }}
                />
              </div>
              <div className="col-md-2 d-flex justify-content-end gap-2">
                <button
                  className="btn createButton"
                  onClick={handleUploadClick}
                >
                  Upload
                </button>
                <button
                  className="btn createButton"
                  onClick={handleCreateClick}
                >
                  Create
                </button>
              </div>
            </div>
            <div className="overflow-auto">
              <table
                className="table table-bordered table-striped mt-2"
                id="aliasesTable"
              >
                <thead className="table-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Aliasword</th>
                    <th scope="col">Created By</th>
                    <th scope="col" className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems
                    .slice(
                      (currentPage - 1) * itemsPerPage,
                      currentPage * itemsPerPage
                    )
                    .map((row, index) => (
                      <tr key={row.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{row.name}</td>
                        <td>{row.aliasword}</td>
                        <td>{row.createdBy}</td>
                        <td className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleEditClick(row)}
                          >
                            <MdEdit /> Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(row.id)}
                          >
                            <MdDelete /> Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <div className="pagination">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleFirstPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  First
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  Prev
                </Button>
                <span className="mx-2 align-self-center">
                  Page {currentPage} of{" "}
                  {Math.ceil(filteredItems.length / itemsPerPage)}
                </span>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleNextPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                  className="me-2"
                >
                  Next
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleLastPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                >
                  Last
                </Button>
              </div>
            </div>
          </>
        )}

        {/* Anglicized Table */}
        {selectedTab === 2 && (
          <>
            <div className="row mb-3 justify-content-between align-items-center">
              <div className="col-md-2">
                <TextField
                  fullWidth
                  size="small"
                  variant="standard"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdSearch />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottom: "2px solid var(--theme-color)",
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottom: "2px solid rgba(0, 0, 0, 0.87)",
                    },
                  }}
                />
              </div>
              <div className="col-md-2 d-flex justify-content-end gap-2">
                <button
                  className="btn createButton"
                  onClick={handleUploadClick}
                >
                  Upload
                </button>
                <button
                  className="btn createButton"
                  onClick={handleCreateClick}
                >
                  Create
                </button>
              </div>
            </div>
            <div className="overflow-auto">
              <table
                className="table table-bordered table-striped mt-2"
                id="anglicizedTable"
              >
                <thead className="table-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Anglicized Name</th>
                    <th scope="col">Created By</th>
                    <th scope="col" className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems
                    .slice(
                      (currentPage - 1) * itemsPerPage,
                      currentPage * itemsPerPage
                    )
                    .map((row, index) => (
                      <tr key={row.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{row.name}</td>
                        <td>{row.anglicizedName}</td>
                        <td>{row.createdBy}</td>
                        <td className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleEditClick(row)}
                          >
                            <MdEdit /> Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(row.id)}
                          >
                            <MdDelete /> Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <div className="pagination">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleFirstPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  First
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  Prev
                </Button>
                <span className="mx-2 align-self-center">
                  Page {currentPage} of{" "}
                  {Math.ceil(filteredItems.length / itemsPerPage)}
                </span>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleNextPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                  className="me-2"
                >
                  Next
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleLastPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                >
                  Last
                </Button>
              </div>
            </div>
          </>
        )}

        {/* Bad Data Table */}
        {selectedTab === 3 && (
          <>
            <div className="row mb-3 justify-content-between align-items-center">
              <div className="col-md-2">
                <TextField
                  fullWidth
                  size="small"
                  variant="standard"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdSearch />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottom: "2px solid var(--theme-color)",
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottom: "2px solid rgba(0, 0, 0, 0.87)",
                    },
                  }}
                />
              </div>
              <div className="col-md-2 d-flex justify-content-end gap-2">
                <button
                  className="btn createButton"
                  onClick={handleUploadClick}
                >
                  Upload
                </button>
                <button
                  className="btn createButton"
                  onClick={handleCreateClick}
                >
                  Create
                </button>
              </div>
            </div>
            <div className="overflow-auto">
              <table
                className="table table-bordered table-striped mt-2"
                id="badDataTable"
              >
                <thead className="table-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Description</th>
                    <th scope="col">Created By</th>
                    <th scope="col" className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems
                    .slice(
                      (currentPage - 1) * itemsPerPage,
                      currentPage * itemsPerPage
                    )
                    .map((row, index) => (
                      <tr key={row.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{row.name}</td>
                        <td>{row.description}</td>
                        <td>{row.createdBy}</td>
                        <td className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleEditClick(row)}
                          >
                            <MdEdit /> Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(row.id)}
                          >
                            <MdDelete /> Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <div className="pagination">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleFirstPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  First
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  Prev
                </Button>
                <span className="mx-2 align-self-center">
                  Page {currentPage} of{" "}
                  {Math.ceil(filteredItems.length / itemsPerPage)}
                </span>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleNextPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                  className="me-2"
                >
                  Next
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleLastPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                >
                  Last
                </Button>
              </div>
            </div>
          </>
        )}

        {/* Double Letters Table */}
        {selectedTab === 4 && (
          <>
            <div className="row mb-3 justify-content-between align-items-center">
              <div className="col-md-2">
                <TextField
                  fullWidth
                  size="small"
                  variant="standard"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdSearch />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottom: "2px solid var(--theme-color)",
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottom: "2px solid rgba(0, 0, 0, 0.87)",
                    },
                  }}
                />
              </div>
              <div className="col-md-2 d-flex justify-content-end gap-2">
                <button
                  className="btn createButton"
                  onClick={handleUploadClick}
                >
                  Upload
                </button>
                <button
                  className="btn createButton"
                  onClick={handleCreateClick}
                >
                  Create
                </button>
              </div>
            </div>
            <div className="overflow-auto">
              <table
                className="table table-bordered table-striped"
                id="doubleLettersTable"
              >
                <thead className="table-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Letter</th>
                    <th scope="col">Replace Letter</th>
                    <th scope="col">Created By</th>
                    <th scope="col" className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems
                    .slice(
                      (currentPage - 1) * itemsPerPage,
                      currentPage * itemsPerPage
                    )
                    .map((row, index) => (
                      <tr key={row.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{row.name}</td>
                        <td>{row.replaceLetter}</td>
                        <td>{row.createdBy}</td>
                        <td className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleEditClick(row)}
                          >
                            <MdEdit /> Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(row.id)}
                          >
                            <MdDelete /> Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <div className="pagination">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleFirstPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  First
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  Prev
                </Button>
                <span className="mx-2 align-self-center">
                  Page {currentPage} of{" "}
                  {Math.ceil(filteredItems.length / itemsPerPage)}
                </span>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleNextPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                  className="me-2"
                >
                  Next
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleLastPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                >
                  Last
                </Button>
              </div>
            </div>
          </>
        )}

        {/* Initials Table */}
        {selectedTab === 5 && (
          <>
            <div className="row mb-3 justify-content-between align-items-center">
              <div className="col-md-2">
                <TextField
                  fullWidth
                  size="small"
                  variant="standard"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdSearch />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottom: "2px solid #1976d2",
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottom: "2px solid rgba(0, 0, 0, 0.87)",
                    },
                  }}
                />
              </div>
              <div className="col-md-2 d-flex justify-content-end gap-2">
                <button
                  className="btn createButton"
                  onClick={handleUploadClick}
                >
                  Upload
                </button>
                <button
                  className="btn createButton"
                  onClick={handleCreateClick}
                >
                  Create
                </button>
              </div>
            </div>
            <div className="overflow-auto">
              <table
                className="table table-bordered table-striped mt-2"
                id="initialsTable"
              >
                <thead className="table-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Initial</th>
                    <th scope="col">Created By</th>
                    <th scope="col" className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems
                    .slice(
                      (currentPage - 1) * itemsPerPage,
                      currentPage * itemsPerPage
                    )
                    .map((row, index) => (
                      <tr key={row.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{row.name}</td>
                        <td>{row.initial}</td>
                        <td>{row.createdBy}</td>
                        <td className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleEditClick(row)}
                          >
                            <MdEdit /> Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(row.id)}
                          >
                            <MdDelete /> Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <div className="pagination">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleFirstPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  First
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  Prev
                </Button>
                <span className="mx-2 align-self-center">
                  Page {currentPage} of{" "}
                  {Math.ceil(filteredItems.length / itemsPerPage)}
                </span>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleNextPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                  className="me-2"
                >
                  Next
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleLastPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                >
                  Last
                </Button>
              </div>
            </div>
          </>
        )}

        {/* Nicknames Table */}
        {selectedTab === 6 && (
          <>
            <div className="row mb-3 justify-content-between align-items-center">
              <div className="col-md-2">
                <TextField
                  fullWidth
                  size="small"
                  variant="standard"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdSearch />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                    },
                    "& .MuiInput-underline:after": {
                      // borderBottom: '2px solid var(--theme-color)',
                      borderBottom: "2px solid red",
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottom: "2px solid rgba(0, 0, 0, 0.87)",
                    },
                  }}
                />
              </div>
              <div className="col-md-2 d-flex justify-content-end gap-2">
                <button
                  className="btn createButton"
                  onClick={handleUploadClick}
                >
                  Upload
                </button>
                <button
                  className="btn createButton"
                  onClick={handleCreateClick}
                >
                  Create
                </button>
              </div>
            </div>
            <div className="overflow-auto">
              <table
                className="table table-bordered table-striped mt-2"
                id="nicknamesTable"
              >
                <thead className="table-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Nickname</th>
                    <th scope="col">Created By</th>
                    <th scope="col" className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems
                    .slice(
                      (currentPage - 1) * itemsPerPage,
                      currentPage * itemsPerPage
                    )
                    .map((row, index) => (
                      <tr key={row.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{row.name}</td>
                        <td>{row.nickname}</td>
                        <td>{row.createdBy}</td>
                        <td className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleEditClick(row)}
                          >
                            <MdEdit /> Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(row.id)}
                          >
                            <MdDelete /> Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <div className="pagination">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleFirstPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  First
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  Prev
                </Button>
                <span className="mx-2 align-self-center">
                  Page {currentPage} of{" "}
                  {Math.ceil(filteredItems.length / itemsPerPage)}
                </span>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleNextPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                  className="me-2"
                >
                  Next
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleLastPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                >
                  Last
                </Button>
              </div>
            </div>
          </>
        )}

        {/* Intervining Table */}
        {selectedTab === 7 && (
          <>
            <div className="row mb-3 justify-content-between align-items-center">
              <div className="col-md-2">
                <TextField
                  fullWidth
                  size="small"
                  variant="standard"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdSearch />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottom: "2px solid var(--theme-color)",
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottom: "2px solid rgba(0, 0, 0, 0.87)",
                    },
                  }}
                />
              </div>
              <div className="col-md-2 d-flex justify-content-end gap-2">
                <button
                  className="btn createButton"
                  onClick={handleUploadClick}
                >
                  Upload
                </button>
                <button
                  className="btn createButton"
                  onClick={handleCreateClick}
                >
                  Create
                </button>
              </div>
            </div>
            <div className="overflow-auto">
              <table
                className="table table-bordered table-striped mt-2"
                id="interviningTable"
              >
                <thead className="table-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Word List</th>
                    <th scope="col">Description</th>
                    <th scope="col">Created By</th>
                    <th scope="col" className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems
                    .slice(
                      (currentPage - 1) * itemsPerPage,
                      currentPage * itemsPerPage
                    )
                    .map((row, index) => (
                      <tr key={row.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{row.wordList}</td>
                        <td>{row.description}</td>
                        <td>{row.createdBy}</td>
                        <td className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleEditClick(row)}
                          >
                            <MdEdit /> Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(row.id)}
                          >
                            <MdDelete /> Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <div className="pagination">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleFirstPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  First
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  className="me-2"
                >
                  Prev
                </Button>
                <span className="mx-2 align-self-center">
                  Page {currentPage} of{" "}
                  {Math.ceil(filteredItems.length / itemsPerPage)}
                </span>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleNextPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                  className="me-2"
                >
                  Next
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleLastPage}
                  disabled={
                    currentPage ===
                    Math.ceil(filteredItems.length / itemsPerPage)
                  }
                >
                  Last
                </Button>
              </div>
            </div>
          </>
        )}

        {selectedTab === 8 && (
          <>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                  <TextField
                    fullWidth
                    size="small"
                    variant="standard"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={handleSearch}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MdSearch />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiInput-underline:before": {
                        borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottom: "2px solid var(--theme-color)",
                      },
                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottom: "2px solid rgba(0, 0, 0, 0.87)",
                      },
                    }}
                  />
                </div>
                <button
                    className="btn createButton mx-2"
                    onClick={handleMt202Import}
                >
                    Import
                </button>
            </div>
            <div className="table-responsive mb-3">
              <table className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>File Name</th>
                    <th>Uploaded At</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {mt202Files.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No files uploaded
                      </td>
                    </tr>
                  ) : (
                    mt202Files.map((file, idx) => (
                      <tr key={file.id}>
                        <td>{idx + 1}</td>
                        <td>{file.fileName}</td>
                        <td>{file.uploadedAt}</td>
                        <td className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            className="btn btn-primary  btn-sm"
                            onClick={() => setMt202ViewRow(file)}
                          >
                            <MdRemoveRedEye /> View
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(file.id)}
                          >
                            <MdDelete /> Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                
                </tbody>
              </table>
            </div>
            <div className="mb-3 text-center">
              <button
                className="btn createButton mx-2"
                onClick={handleMt202Generate}
                disabled={mt202Files.length === 0}
              >
                Generate
              </button>
            </div>
            {/* Generate Table (like Data Selection) */}
            {mt202Generate && !mt202Apply && (
              <div className="card p-3 mb-3">
                <h6>MT202 Data Selection Table</h6>
                <div className="table-responsive">
                  <table
                    id="fileTable"
                    className="table table-bordered table-striped"
                  >
                    <thead className="table-dark">
                      <tr>
                        <th>#</th>
                        <th>1:</th>
                        <th>2:</th>
                        <th>3:</th>
                        <th>4:</th>
                        <th>:20:</th>
                        <th>:23B:</th>
                        <th>:32A:</th>
                        <th>:50A:</th>
                        <th>:57A:</th>
                        <th>:59:</th>
                        <th>:70:</th>
                        <th>:71A:</th>
                        <th>:72:</th>
                      </tr>
                    </thead>
                    <tbody>
                      {previewTableData.map((row, index) => (
                        <tr key={row.id}>
                          <td>{indexOfFirstItem + index + 1}</td>
                          <td>{row.col1}</td>
                          <td>{row.col2}</td>
                          <td>{row.col3}</td>
                          <td>{row.col4}</td>
                          <td>{row.col20}</td>
                          <td>{row.col23B}</td>
                          <td>{row.col32A}</td>
                          <td>{row.col50A}</td>
                          <td>{row.col57A}</td>
                          <td>{row.col59}</td>
                          <td>{row.col70}</td>
                          <td>{row.col71A}</td>
                          <td>{row.col72}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* <button className="btn btn-primary" onClick={handleMt202Apply}>
                  Apply
                </button> */}
              </div>
            )}
            {/* Final Table after Apply */}
            {mt202Apply && (
              <div className="card p-3">
                <h6>MT202 Final Table</h6>
                <table className="table table-bordered table-striped">
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>File Name</th>
                      <th>Uploaded At</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    {mt202Files.map((file, idx) => (
                      <tr key={file.id}>
                        <td>{idx + 1}</td>
                        <td>{file.fileName}</td>
                        <td>{file.uploadedAt}</td>
                        
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {mt202ImportModal && (
              <div className="modal-overlay">
                <div
                  className="modal-container bg-white p-4"
                  style={{ maxWidth: "90%", width: "90%" }}
                >
                  <h5 className="mb-3">Import MT202 File</h5>
                  <div className="choose-file-input d-flex align-items-center">
                    <label
                      className="btn choose-file-btn me-2"
                      htmlFor="mt202FileInput"
                    >
                      Choose File
                    </label>
                    <input
                      id="mt202FileInput"
                      type="file"
                      style={{ display: "none" }}
                      accept=".txt,.csv,.xlsx,.xls,.pdf"
                      onChange={handleMt202FileChange}
                    />
                    <p
                      className="mb-0 choose-file-name flex-grow-1"
                      onClick={() =>
                        document.getElementById("mt202FileInput").click()
                      }
                    >
                      {mt202File ? mt202File.name : "No file chosen"}
                    </p>
                  </div>
                  <div className="d-flex justify-content-center mt-3">
                    <button
                      type="button"
                      className="btn cancelButton me-2"
                      // disabled={!mt202File}
                      onClick={() => setMt202ImportModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn createButton"
                      // disabled={!mt202File}
                      onClick={handleMt202Submit}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
            {mt202ViewRow && (
                <div className="modal-overlay">
                    <div className="modal-container bg-white p-4" style={{ maxWidth: "90%", width: "90%" }}>
                    <h5 className="mb-3">MT202 Row Details</h5>
                    <table className="table table-bordered table-striped">
                        <thead className="table-dark">
                        <tr>
                            <th>S.No</th>
                            <th>Name</th>
                            <th>Type</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>1</td>
                            <td>Sri Harsha</td>
                            <td>Positive</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Tejaswini</td>
                            <td>Negative</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Vinay</td>
                            <td>Positive</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Pavan</td>
                            <td>Negative</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>Pravallika</td>
                            <td>Positive</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>Aparna</td>
                            <td>Negative</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>Jyothsna</td>
                            <td>Positive</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>Sunitha</td>
                            <td>Positive</td>
                        </tr>
                        <tr>
                            <td>9</td>
                            <td>Abhi</td>
                            <td>Negative</td>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td>Akash</td>
                            <td>Positive</td>
                        </tr>
                        
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-center mt-3">
                        <button className="btn createButton" onClick={() => setMt202ViewRow(null)}>
                        Close
                        </button>
                    </div>
                    </div>
                </div>
                )}
          </>
        )}

        {/* Create Modal */}
        <Modal
          open={createModalOpen}
          onClose={() => setCreateModalOpen(false)}
          aria-labelledby="create-modal-title"
        >
          <div className="modal-overlay">
            <div
              className="modal-container bg-white p-4 rounded"
              style={{ width: 400, maxWidth: "90vw" }}
            >
              <h5 id="create-modal-title">
                Create New{" "}
                {selectedTab === 0
                  ? "Abbreviation"
                  : selectedTab === 1
                  ? "Alias"
                  : selectedTab === 2
                  ? "Anglicized Name"
                  : selectedTab === 3
                  ? "Bad Data"
                  : selectedTab === 4
                  ? "Double Letter"
                  : selectedTab === 5
                  ? "Initial"
                  : selectedTab === 6
                  ? "Nickname"
                  : "Intervining"}
              </h5>
              <form onSubmit={handleCreateSubmit}>
                {selectedTab === 7 ? (
                  <>
                    <TextField
                      fullWidth
                      label="Word List"
                      name="wordList"
                      value={createFormData.wordList}
                      onChange={handleCreateFormChange}
                      margin="normal"
                    />
                    <TextField
                      fullWidth
                      label="Description"
                      name="description"
                      value={createFormData.description}
                      onChange={handleCreateFormChange}
                      margin="normal"
                    />
                  </>
                ) : (
                  <>
                    <TextField
                      fullWidth
                      label="Name"
                      name="name"
                      value={createFormData.name}
                      onChange={handleCreateFormChange}
                      margin="normal"
                    />
                    {selectedTab === 0 ? (
                      <TextField
                        fullWidth
                        label="Abbreviation"
                        name="abbreviation"
                        value={createFormData.abbreviation}
                        onChange={handleCreateFormChange}
                        margin="normal"
                      />
                    ) : selectedTab === 1 ? (
                      <TextField
                        fullWidth
                        label="Aliasword"
                        name="aliasword"
                        value={createFormData.aliasword}
                        onChange={handleCreateFormChange}
                        margin="normal"
                      />
                    ) : selectedTab === 2 ? (
                      <TextField
                        fullWidth
                        label="Anglicized Name"
                        name="anglicizedName"
                        value={createFormData.anglicizedName}
                        onChange={handleCreateFormChange}
                        margin="normal"
                      />
                    ) : selectedTab === 3 ? (
                      <TextField
                        fullWidth
                        label="Description"
                        name="description"
                        value={createFormData.description}
                        onChange={handleCreateFormChange}
                        margin="normal"
                      />
                    ) : selectedTab === 4 ? (
                      <TextField
                        fullWidth
                        label="Replace Letter"
                        name="replaceLetter"
                        value={createFormData.replaceLetter}
                        onChange={handleCreateFormChange}
                        margin="normal"
                      />
                    ) : selectedTab === 5 ? (
                      <TextField
                        fullWidth
                        label="Initial"
                        name="initial"
                        value={createFormData.initial}
                        onChange={handleCreateFormChange}
                        margin="normal"
                      />
                    ) : (
                      <TextField
                        fullWidth
                        label="Nickname"
                        name="nickname"
                        value={createFormData.nickname}
                        onChange={handleCreateFormChange}
                        margin="normal"
                      />
                    )}
                  </>
                )}
                <div className="d-flex justify-content-end gap-2 mt-2">
                  <button
                    className="btn cancelButton"
                    onClick={() => setCreateModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn createButton" type="submit">
                    Create
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        {/* Edit Modal */}
        <Modal
          open={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          aria-labelledby="edit-modal-title"
        >
          <div className="modal-overlay">
            <div
              className="modal-container bg-white p-4 rounded"
              style={{ width: 400, maxWidth: "90vw" }}
            >
              <h5 id="edit-modal-title">
                Edit{" "}
                {selectedTab === 0
                  ? "Abbreviation"
                  : selectedTab === 1
                  ? "Alias"
                  : selectedTab === 2
                  ? "Anglicized Name"
                  : selectedTab === 3
                  ? "Bad Data"
                  : selectedTab === 4
                  ? "Double Letter"
                  : selectedTab === 5
                  ? "Initial"
                  : selectedTab === 6
                  ? "Nickname"
                  : "Intervining"}
              </h5>
              <form onSubmit={handleEditSubmit}>
                {selectedTab === 7 ? (
                  <>
                    <TextField
                      fullWidth
                      label="Word List"
                      name="wordList"
                      value={editFormData.wordList}
                      onChange={handleEditFormChange}
                      margin="normal"
                    />
                    <TextField
                      fullWidth
                      label="Description"
                      name="description"
                      value={editFormData.description}
                      onChange={handleEditFormChange}
                      margin="normal"
                    />
                  </>
                ) : (
                  <>
                    <TextField
                      fullWidth
                      label="Name"
                      name="name"
                      value={editFormData.name}
                      onChange={handleEditFormChange}
                      margin="normal"
                    />
                    {selectedTab === 0 ? (
                      <TextField
                        fullWidth
                        label="Abbreviation"
                        name="abbreviation"
                        value={editFormData.abbreviation}
                        onChange={handleEditFormChange}
                        margin="normal"
                      />
                    ) : selectedTab === 1 ? (
                      <TextField
                        fullWidth
                        label="Aliasword"
                        name="aliasword"
                        value={editFormData.aliasword}
                        onChange={handleEditFormChange}
                        margin="normal"
                      />
                    ) : selectedTab === 2 ? (
                      <TextField
                        fullWidth
                        label="Anglicized Name"
                        name="anglicizedName"
                        value={editFormData.anglicizedName}
                        onChange={handleEditFormChange}
                        margin="normal"
                      />
                    ) : selectedTab === 3 ? (
                      <TextField
                        fullWidth
                        label="Description"
                        name="description"
                        value={editFormData.description}
                        onChange={handleEditFormChange}
                        margin="normal"
                      />
                    ) : selectedTab === 4 ? (
                      <TextField
                        fullWidth
                        label="Replace Letter"
                        name="replaceLetter"
                        value={editFormData.replaceLetter}
                        onChange={handleEditFormChange}
                        margin="normal"
                      />
                    ) : selectedTab === 5 ? (
                      <TextField
                        fullWidth
                        label="Initial"
                        name="initial"
                        value={editFormData.initial}
                        onChange={handleEditFormChange}
                        margin="normal"
                      />
                    ) : (
                      <TextField
                        fullWidth
                        label="Nickname"
                        name="nickname"
                        value={editFormData.nickname}
                        onChange={handleEditFormChange}
                        margin="normal"
                      />
                    )}
                  </>
                )}
                <div className="d-flex justify-content-end gap-2 mt-2">
                  <button
                    className="btn cancelButton"
                    onClick={() => setEditModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn createButton" type="submit">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default ReferenceData;
